import SmartPillLogData from '../store/schema/SmartPillLogData';
import logUnsampledDatapoint from './logUnsampledDatapoint';

/**
 * This method will be used in the future, once new scorecards are created for the datapoint schema
 */
export default function logOnClickDatapoint(
    logData: SmartPillLogData,
    datapointName: string
): void {
    const pillObj = {
        data: [logData.mainPayload],
    };

    logUnsampledDatapoint(datapointName, [JSON.stringify(pillObj)], logData.cosmosOnlyData);
}

/**
 * Needed temporarily so that existing smart reply scorecards don't break.
 * Datapoint must be backward compatible with old implementation's.
 * @param extractionID GUID from stamped property.
 * @param index Position of smart reply.
 * @param loggableText The loggable smart reply itself (no PII).
 * @param featureName The type of pill (e.g. SmartTime)
 * @param language: The language of the message, for experimentation.
 * @param locale: The locale of the message, for experimentation.
 * @param internetMessageId: IMI, requested by FocusedInbox team
 * @param subtype: The subtype of pill (e.g. the text on the menu button)
 */
export function logOnClickDatapointLegacy(
    extractionID: string,
    index: number,
    loggableText: string,
    featureName: string,
    language: string,
    locale: string,
    internetMessageId: string,
    subtype?: string
): void {
    logUnsampledDatapoint(
        'SmartReply_Clicked',
        [
            extractionID,
            index,
            loggableText,
            false /* isInConversationMode -- deprecated */,
            featureName,
            language,
            locale,
            subtype,
        ],
        internetMessageId // cosmosOnlyData
    );
}
